import Box from '@redbubble/design-system/src/Box';
import { defineMessages, useIntl } from '@redbubble/next/intl';
import { AppProps } from '@redbubble/next/types';
import { usePageProps } from '@redbubble/next-provider';
import React, { useState } from 'react';
import { ProductPageProps } from '../../types';
import { CountdownTimer } from './CountdownTimer/CountdownTimer';
import styles from './DiscountPromo.module.scss';
import { Star } from './Star/Star';

const messages = defineMessages({
  discountPromoText: {
    defaultMessage: '{discount}% off ends soon',
  },
  discountPromoTextWithCountdown: {
    defaultMessage: '{discount}% off ends in',
  },
});

interface DiscountPromoProps {
  discount: number;
}

export const DiscountPromo: React.FC<DiscountPromoProps> = ({ discount }) => {
  const intl = useIntl();
  const { initialSeconds } = usePageProps<AppProps & ProductPageProps>();
  const [seconds] = useState(initialSeconds);

  const showCountdown = seconds > 0;

  const discountMessage = showCountdown
    ? intl.formatMessage(messages.discountPromoTextWithCountdown, { discount })
    : intl.formatMessage(messages.discountPromoText, { discount });

  return (
    <Box display="flex" className={styles.discountPromoContainer}>
      <div className={styles.starBox}>
        <Star rotation={0} size={30} x={1} y={showCountdown ? 30 : 27} />
        <Star rotation={5} size={50} x={-3} y={0} />
      </div>

      <div
        className={[
          styles.text,
          showCountdown ? styles.countdownText : '',
        ].join(' ')}
      >
        <span className={styles.discountMessage}>{discountMessage}</span>
        {showCountdown && <CountdownTimer secondsLeft={seconds} />}
      </div>

      <div className={styles.mobileStarBox}>
        <Star
          rotation={-5}
          size={50}
          x={showCountdown ? 5 : 0}
          y={showCountdown ? -5 : 0}
        />
        <Star rotation={15} size={30} x={0} y={27} />
      </div>

      <div className={styles.desktopStarBox}>
        <Star rotation={15} size={45} x={10} y={0} />
        <Star rotation={30} size={30} x={23} y={0} />
      </div>
    </Box>
  );
};
